import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useParams } from 'react-router-dom';
import FormComponent from '../../../Reusable_Components/FormComponent';
import { API_ROUTES, API_DOMAIN, headers } from '../../../Reusable_Components/Config/apiConfig';

const CustomerNotesInput = () => {
  const { noteId = '' } = useParams();
  const decodedId = noteId ? atob(noteId) : noteId;
  const id = decodedId.replace(/\D/g, '');
  const [isEditing, setIsEditing] = useState(false);
  const [formData, setFormData] = useState({});
  const route = 'customerNote';

  useEffect(() => {
    if (noteId) {
      setIsEditing(true);
      fetchNoteDetails();
    }
  }, [noteId]); // eslint-disable-line react-hooks/exhaustive-deps

  const fetchNoteDetails = async () => {
    try {
      const response = await axios.get(`${API_DOMAIN}${API_ROUTES.customerNote}${id}/`, { headers });
      setFormData(response.data);
    } catch (error) {
      console.error('Error fetching customer note details:', error);
    }
  };

  const noteFields = [
    {
      name: 'customer', label: 'Customer', type: 'async-select', required: true,
      endpoint: API_ROUTES.customer,
      getOptionLabel: (c) => c.name,
    },
    {
      name: 'user', label: 'User', type: 'async-select', required: true,
      endpoint: API_ROUTES.users,
      getOptionLabel: (u) => u.username,
    },
    { name: 'text', label: 'Note Text', type: 'textarea', required: true },
  ];

  return (
    <div>
      <h1>{isEditing ? 'Edit Customer Note' : 'Create Customer Note'}</h1>
      <FormComponent fields={noteFields} initialFormData={formData} route={route} cancelPath="/customer/note/list" />
    </div>
  );
};

export default CustomerNotesInput;
